const RETRY_ERROR_TEXT = 'vui lòng thử lại'

/**
 * Message hiển thị khi gửi OTP lỗi.
 * - BE trả lỗi chung chung "Vui lòng thử lại" -> hiển thị `retryMessage` ("Không thể gửi OTP")
 * - Lỗi khác -> giữ nguyên message BE, không có thì dùng `fallback`
 * @param source error bị throw hoặc response lỗi từ API
 */
export const getSendOtpErrorMessage = (
  source: unknown,
  retryMessage: string,
  fallback: string
) => {
  const message =
    typeof source === 'object' &&
    source !== null &&
    'message' in source &&
    typeof source.message === 'string'
      ? source.message.trim()
      : ''

  if (message.toLowerCase().includes(RETRY_ERROR_TEXT)) return retryMessage

  return message || fallback
}
